module.exports = __webpack_public_path__ + "img/05—Applications—Central Storage > Inline Edit > II.13ed145a.jpg";